import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Config } from '../../config/env.config';
import { BaseHttpService } from '../../base/_base-http.service';
import { contentHeaders } from 'common/headers';
import * as _ from 'lodash';
import {catchError} from 'rxjs/operators';

@Injectable()
export class CreateNewProductService extends BaseHttpService {

  private rootUrl: string = 'items';

  post(brandId: string, data: any): Observable<any> {
    const body = JSON.stringify({ data });
    return this.http.post(`${Config.API}/${this.rootUrl}/${brandId}`, body, {headers: contentHeaders})

        .pipe(catchError(this.handleError.bind(this)));
  }

  partNumberAvailability(brandId: string, partNumber: any): Observable<any> {
    const body = JSON.stringify({ partNumber });
    return this.http.put(`${Config.API}/${this.rootUrl}/${brandId}/part-number-available`, body, {headers: contentHeaders})

        .pipe(catchError(this.handleError.bind(this)));
  }

  createProductCopy(brandId: string, data) {
    const body = JSON.stringify({
      data: {
        partNumber: data.partNumber,
        product_copy_id: data.productCopyId.toString(),
        data_to_copy: data.dataToCopy,
      }
    });
    return this.http.post(`${Config.API}/${this.rootUrl}/${brandId}`, body, {headers: contentHeaders})
      .pipe(catchError(this.handleError.bind(this)));
  }

  copyProductData(brandId: string, itemId, data) {
    const body = JSON.stringify({
      data: {
        product_ids: data.productIds,
        product_copy_id: itemId,
        data_to_copy: data.dataToCopy,
      }
    });
    return this.http.put(`${Config.API}/${this.rootUrl}/${brandId}/${itemId}/product-copy`, body, {headers: contentHeaders})
      .pipe(catchError(this.handleError.bind(this)));
  }
}
